export default __webpack_public_path__ + "static/media/peru2021.75390416.jpg";